<script>
import ArtistSearch from '@/components/artist/ArtistSearch.vue'
import { queryOrderSourceArtistDivide, syncOrdersArtistDivide } from '@/api/artist_divide'
import { copyTextToClipboard } from '@/utils/sys/copy'

export default {
  name: 'OrderSourcePanel',
  components: { ArtistSearch },
  data() {
    return {
      dialogFormVisible: false,
      dialogLoading: false,
      artistSelectorVisible: false,
      dialogArtistVisible: false,
      loadingSync: false,
      dialogTitle: '',
      dialogForm: {
        id: 0,
        date_time: '',
        artist_id: '',
        nickname: '',
        commerce_pay: 0,//卖货分成
        publicity_pay: 0,//推广分成
        brokerage_pay: 0,//佣金分成
        other_pay: 0, // 其他应扣/补款
        marketing_costs: 0,//承担的营销费用
        due_total: 0,//应付款合计
        person_tax: 0,//个税
        actual_pay: 0,//实付款
        invoice_amount: 0,//发票总额
        deduct_remark: '',
        settle_method: 'corporate',
        need_invoice: 'Y',
        apply_time: null,
        payment_time: null,
        remark: '',
        invoice_type: null,
        tax_point: null
      },
      dialogFormRules: {
        date_time: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ],
        nickname: [
          { required: true, message: '请选择红人', trigger: 'change' }
        ],
        settle_method: [
          { required: true, message: '请选择结算方式', trigger: 'change' }
        ]
        // artist_id: [
        //   { required: true, message: '请选择红人', trigger: 'change' }
        // ]
      },
      activeName: 'entire_orders',
      dataList: [],
      pageData: {
        page_size: 10,
        current_page: 1
      },
      total: 0
    }
  },
  methods: {
    open(dialogForm) {
      // console.log(dialogForm)
      this.dialogFormVisible = true
      this.dialogTitle = `${dialogForm.nickname}的【${dialogForm.date_time}】的订单明细（星广汇-收入汇总）`
      this.dialogForm = { ...dialogForm }
      this.getList()
    },

    async getList() {
      //
      const params = {
        artist_id: this.dialogForm.artist_id,
        date_month: this.dialogForm.date_time,
        type: this.activeName,
        page: this.pageData.current_page,
        per_page: this.pageData.page_size
      }
      // console.log(params)
      const { list, page, per_page, total } = await queryOrderSourceArtistDivide(params)
      this.dataList = list || []
      this.pageData.current_page = page || 1
      this.pageData.per_page = per_page | 10
      this.total = total || 0
    },
    handleClick() {
      this.getList()
    },
    handleRowClick(row, column) {
      const text = row[column.property] || ''
      copyTextToClipboard(text)
      this.$notify.success(`复制成功:${text}`)
    },
    async handleSyncOrders() {
      this.loadingSync = true
      this.$confirm('确认【重新同步】订单明细，同步后将重新更正为【星广汇系统-收入汇总：全案保量、商务收入】的订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await syncOrdersArtistDivide(this.dialogForm.id)
        setTimeout(()=>{
          this.loadingSync = false
          this.msgSuccess('已触发同步，请稍后【刷新】页面查看结果')
          this.$emit('synced')
        },2000)
      }).catch(() => {
        this.$notify.info('已取消')
      })

    }
  }
}
</script>

<template>
  <el-dialog center :title='dialogTitle' :visible.sync='dialogFormVisible' width='1024px'>
    <div>
      <el-tabs v-model='activeName' @tab-click='handleClick'>
        <el-tab-pane name='entire_orders' label='全案保量'>

        </el-tab-pane>
        <el-tab-pane name='income_orders' label='商务收入'>

        </el-tab-pane>
      </el-tabs>
      <el-table :border='true' :data='dataList' @row-dblclick='handleRowClick'>
        <el-table-column align='center' label='序号' width='60'>
          <template slot-scope='scope'>
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column align='center' label='订单ID' prop='sid' width='100' />-->
        <el-table-column align='center' label='订单编号' prop='order_no' width='160' show-overflow-tooltip />
        <el-table-column align='center' label='红人昵称' prop='kol_nickname' width='120' />
        <el-table-column align='center' label='经纪人' prop='agent_name' width='120' />
        <!--                      <el-table-column align='center' label='经纪人' prop='agent_name' class-name='table-cell' />-->
        <el-table-column align='center' label='执行时间' prop='exec_date' width='120' />
        <el-table-column align='center' label='品牌' prop='brand' width='120' />
        <el-table-column align='center' label='产品' prop='product' width='120' />
        <el-table-column align='right' label='可分配收入' prop='exec_price' width='120'>
          <template slot-scope='{ row }'>
            <span>{{ row.exec_price }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div>
        <Pagination
          :limit.sync='pageData.page_size'
          :page.sync='pageData.current_page'
          :total='total'
          @pagination='getList' />
      </div>
    </div>
    <div slot='footer' class='dialog-footer'>
      <!--      <el-button @click='dialogFormVisible = false'>取 消</el-button>-->
      <el-button type='primary' round size='small' @click='handleSyncOrders' :loading='loadingSync' :disabled='loadingSync'>同步订单明细
      </el-button>
    </div>
  </el-dialog>
</template>

<style scoped>

</style>
